import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { LookerFolder } from 'lumen/models';

export default class LookerLook extends Model {
  [Type] = 'looker-look' as const;

  @belongsTo('looker-folder', { async: false, inverse: 'looks' })
  declare folder: LookerFolder;

  @attr('string') declare description: string;
  @attr('string') declare title: string;
}
